import React, { Component } from 'react';
import Timestamp from './Timestamp';
import Octicon, {Organization} from '@githubprimer/octicons-react';

class TournamentInfo extends Component {

  tournamentType() {
    const typeEnum = this.props.tournament.type;
    if (typeEnum === 'INDIVIDUAL') {
      return 'indywiduel';
    } else if (typeEnum === 'TEAMS') {
      return 'turniej teamów';
    } else {
      return 'turniej par';
    }
  }

  tournamentRank() {
    const rankEnum = this.props.tournament.rank;
    if (rankEnum === 'OTP_THREE_STARS') {
      return 'OTP***';
    } else if (rankEnum === 'OTP_TWO_STARS') {
      return 'OTP**';
    } else if (rankEnum === 'OTP_ONE_STAR') {
      return 'OTP*';
    } else if (rankEnum === 'OTP') {
      return 'OTP';
    } else if (rankEnum === 'RTP_ONE_STAR') {
      return 'RTP*';
    } else if (rankEnum === 'RTP') {
      return 'RTP';
    } else {
      return '';
    }
  }

  pricingPanel() {
    const tournament = this.props.tournament;
    return (
      <div className="d-inline-block border rounded bg-light pl-2 pr-2 ml-3 mr-3">
        { tournament.pricing.type === 'PLAYER' ? this.playerPricing() : this.participantPricing() }  
      </div>
    );
  }

  playerPricing() {
    const tournament = this.props.tournament;

    return (
      <div>
        <div className="mt-2 mb-2"><b>Wpisowe od zawodnika:</b></div>
        <div className="d-inline-block align-top mr-3">
            <div className="mb-1">Niezrzeszony {tournament.pricing.nonAssociatedPlayerPrice} zł</div>
            <div className="mb-1">Normalne {tournament.pricing.regularPrice} zł</div>
            { this.reducedPricesInfo() }
        </div>
      </div>
    );
  }

  reducedPricesInfo() {
    const tournament = this.props.tournament;
    if (tournament.pricing.juniorPrice === tournament.pricing.seniorPrice &&
      tournament.pricing.seniorPrice === tournament.pricing.youngsterPrice) {
      return (
        <div>
          <div className="mb-1">Ulgowe {tournament.pricing.juniorPrice} zł</div>
        </div>
      );
    } else if (tournament.pricing.juniorPrice === tournament.pricing.seniorPrice) {
      return (
        <div>
          <div className="mb-1">Ulgowe {tournament.pricing.juniorPrice} zł</div>
          <div className="mb-1">Młodzież szkolna {tournament.pricing.youngsterPrice} zł</div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="mb-1">Junior {tournament.pricing.juniorPrice} zł</div>
          <div className="mb-1">Senior {tournament.pricing.seniorPrice} zł</div>
          <div className="mb-1">Młodzież szkolna {tournament.pricing.youngsterPrice} zł</div>
        </div>
      );
    }
  }

  participantPricing() {
    const tournament = this.props.tournament;

    return (
      <div>
        <div className="mt-2 mb-2"><b>Wpisowe od zgłoszenia:</b></div>
        <div className="d-inline-block align-top mr-3">
            <div className="mb-1">Zrzeszeni z opłaconą składką {tournament.pricing.associatedParticipantPrice} zł</div>
            <div className="mb-1">Pozostali {tournament.pricing.nonAssociatedParticipantPrice} zł</div>
        </div>
      </div>
    );
  }

  render() {
    const tournament = this.props.tournament;

    return (
        <div>
        <h1>{ tournament.name }</h1>
        <h5>
          <span className="badge badge-info ml-1 mr-1">{this.tournamentType()}</span>
          { this.tournamentRank() ? <span className="badge badge-info ml-1 mr-1">{this.tournamentRank()}</span> : <span></span> }
        </h5>
        <div className="d-inline-block align-top border rounded bg-light p-1 ml-3 mr-3 mb-3">
          <div className="mt-2 mb-2">
            <span className="ml-1 mr-1"><b>Miejsce:</b> { tournament.shortDescription }</span>
          </div>
          <div className="mt-2 mb-2">
            <span className="ml-1 mr-1"><b>Czas rozpoczęcia:</b> <Timestamp value={new Date(Date.parse(tournament.startTime))} /></span>
          </div>
          <div className="mt-2 mb-2">
            <span className="ml-1 mr-1"><b>Kontakt:</b> { tournament.contact }</span>
          </div>
        </div>
        <div className="d-inline-block align-top border rounded bg-light p-1 ml-3 mr-3 mb-3">
          <div className="mt-2 mb-2">
            <span className="ml-1 mr-1"><b>Zarejestrowanych uczestników:</b> <Octicon icon={Organization}/> <span><b>{tournament.registrationInfo.registeredParticipantCount}/{tournament.registrationInfo.participantLimit}</b></span></span>
          </div>
          <div className="mt-2 mb-2">
            <span className="ml-1 mr-1"><b>Zakończenie rejestracji:</b> <Timestamp value={new Date(Date.parse(tournament.registrationInfo.endTime))} /></span>
          </div>
        </div>
        <div>{tournament.pricing ? this.pricingPanel() : ''}</div>
        <div>
          <div className="mt-4 mb-4 col-9 with-line-breaks" dangerouslySetInnerHTML={{__html: tournament.detailedDescription}} />
        </div>
      </div>
    );
  }
}

export default TournamentInfo;



// WEBPACK FOOTER //
// ./components/TournamentInfo.js